import axios from "axios"
import { ticketBaseURL } from "../configs/api";

export const getFaqs = () => {
    return getFetch(`rdRentalFaq`);
};

const getFetch = (url: string, params = {}) => {
    return axios({
        url: ticketBaseURL + url,
        method: "GET",
        params: params
    }).then(response => response.data);
}